import { IonDate } from '../components/IonDate';

const CheckNotNull = Symbol('CheckNotNull');

class CommitteeType {
    public committee_typeID: string = '';
    public label: string = '';
    public description: string = '';
    public sort_priority: number = 0;
    public datetime_created: Date | null = null;
    public datetime_updated: Date | null = null;
    public creatorID: string = '';
    public updaterID: string = '';

    constructor(
        committee_typeID: string,
        label: string,
        description: string,
        sort_priority: string,
        datetime_created: string,
        datetime_updated: string,
        creatorID: string,
        updaterID: string
    ) {
        this.committee_typeID = this[CheckNotNull](committee_typeID) ? committee_typeID : '';
        this.label = this[CheckNotNull](label) ? label : '';
        this.description = this[CheckNotNull](description) ? description : '';
        this.sort_priority = this[CheckNotNull](sort_priority) ? parseInt(sort_priority) : 0;
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
        this.creatorID = this[CheckNotNull](creatorID) ? creatorID : '';
        this.updaterID = this[CheckNotNull](updaterID) ? updaterID : '';
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0) 
            return true;
        else
            return false;
    }
}
export default CommitteeType;